import React from 'react';
import gql from 'graphql-tag';
import { get } from 'lodash';
import { Query } from 'react-apollo';
import { Trans } from 'lingui-react';

// language=GraphQL
const query = gql`
  query apiVersion {
    version {
      version
    }
  }
`;

const threeMinutes = 3 * 60 * 1000;

export default () => (
  <Query query={query} pollInterval={threeMinutes}>
    {({ data }) => (
      <Trans>API Version {get(data, 'version.version', '--')}</Trans>
    )}
  </Query>
);



// WEBPACK FOOTER //
// ./src/compositions/LeftNav/ApiVersion.js